export default "__VITE_ASSET__DanAA3hc__"